import { demonetize } from 'common/utils/strings';

export const sortOptionValuesAscending = (values: string[]) => {
    return [...values]
        .sort((opt1, opt2) => (demonetize(opt1) || 0) - (demonetize(opt2) || 0))
        .map((value) => ({ text: value, value }));
};

export const sortOptionValuesAscendingWithDisabled = (
    values: string[],
    disabled: string[] = []
) => {
    return values
        .concat(disabled)
        .sort((opt1, opt2) => (demonetize(opt1) || 0) - (demonetize(opt2) || 0))
        .map((value) => ({ text: value, value, disabled: disabled.includes(value) }));
};
